import React from 'react'

const MarginBottom = () => {
  return (
    <>
        <div className="flex justify-center items-center my-5">
        <div className="w-11/12 h-[0.2px] border-t border-lyellow" />
      </div>
    </>

  )
}

export default MarginBottom